<mat-form-field class="menu-filter">
  <mat-label>Select Menu Mode</mat-label>
  <mat-select
    matInput
    [attr.data-testid]="'feature_scope_select'"
    [formControl]="featureScopeCtrl"
    [placeholder]="placeholderText"
    >
    <!-- Menu builder option group -->
    <mat-optgroup label="Menu Mode">
      @for (scope of featureScopes; track scope) {
        <div class="remove-padding">
          @if ((isReadonly$ | async)) {
            <mat-option
              [value]="scope.id"
              [attr.data-testid]="scope.id + '_option'"
              >
              {{ scope.name }}
            </mat-option>
          }
          @if (!(isReadonly$ | async)) {
            <mat-option
              [value]="scope.id"
              [attr.data-testid]="scope.id + '_option'"
              >
              {{ scope.name }}
            </mat-option>
          }
        </div>
      }
    </mat-optgroup>
  </mat-select>
</mat-form-field>
